import type { FieldsetDesignTokens } from '@primeuix/themes/types/fieldset';

/**
 * Fieldset component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/fieldset/index.ts
 *
 * Component documentation:
 * https://primeng.org/fieldset
 */
export const fieldsetComponentTokens: Partial<FieldsetDesignTokens> = {
  legend: {
    padding: '0.25rem',
  },
};


